export enum PostBreakpoints {
  md = 750,
  sm = 600,
  xs = 450,
}
